import React from 'react';
import styles from './MarketPlaceCards.module.css';

// A store still syncing has no real name yet — fall back to its id so the
// option is never blank or an unhelpful "Pending".
const storeLabel = (store, idField) => (
    store.store_name && store.store_name !== 'Pending' ? store.store_name : store[idField]
);

// Picks which connected account is the main one. Shared by the Seller Central
// and Vendor Central cards; everything scoped to that marketplace follows it.
const StoreSwitcher = ({ stores, activeId, idField, isSwitching, onChange, label = 'Main account', id }) => {
    if (!stores.length) {
        return null;
    }

    return (
        <div className={styles.storeSwitcher}>
            <label className={styles.storeSwitcherLabel} htmlFor={id}>{label}</label>
            <select
                id={id}
                className={styles.storeSelect}
                value={activeId || ''}
                onChange={onChange}
                disabled={isSwitching || stores.length < 2}
            >
                {stores.map((store) => (
                    <option key={store[idField]} value={store[idField]}>
                        {storeLabel(store, idField)}
                        {store.sync_status === 'syncing' ? ' (syncing)' : ''}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default StoreSwitcher;
